import { EnhancedStore, Middleware, ReducersMapObject, configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";

const devTools = process.env.NODE_ENV === "development";

export function createStore<S>(reducer: ReducersMapObject<S>, middlewares: Array<Middleware>): EnhancedStore {
  const store = configureStore({
    reducer,
    devTools,
    middleware: (getDefaultMiddleware) => {
      return getDefaultMiddleware({ serializableCheck: false }).concat(...middlewares);
    },
  });

  setupListeners(store.dispatch);

  return store;
}
